export enum AreaType
{
    Acceptance = 1, //Yellow
    Shipment = 2,  //Green
}